import { parsePayloadForQuery } from '@/helpers/utils.js';
import axios from 'axios';

const state = {};
const getters = {};
const mutations = {};

const actions = {
  search(state, payload) {
    let queryParams = '?' + parsePayloadForQuery(payload);
    return axios.get(`/unsplash${queryParams}`);
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};